<script setup>
import { readHistory } from '~/utils/localStorage'

const route = useRoute()

const { data: checkURL } = await useFetch('/api/city/checkurl', { query: { path: route.path } })
if (!(checkURL.value?.status === 'OK')) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid URL(area)'
  })
}
const areaName = route.params.area

// seo info
const breadCrumbList = checkURL.value?.breadCrumbList

useCustomMetaPoint({ pointName: checkURL.value?.pointInfo?.name, path: route.path, wntouch: true, type: 'area' })
useCustomJsonldPoint({ breadCrumbList })

// save and read history
let showHistory = []
if (import.meta.client) {
  showHistory = readHistory()
}

// get and prop data
const { data: mapData } = await useFetch('/api/clothes/map', { query: { area: areaName } })
const mapList = mapData.value?.mapList || []
const mapTitle = mapData.value?.mapTitle || ''
const pickupList = mapData.value?.pickupList || []
</script>

<template>
  <div>
    <NuxtLayout
      :bread-crumb-list="breadCrumbList"
      ads-key="area"
      name="common"
    >
      <ClothesMap
        :map-area="areaName"
        :map-list="mapList"
        :map-title="mapTitle"
        :type="'area'"
      />
      <ClothesGps />
      <!-- ads-atf のみ、Layout 内部にあるので、個別に記載。(他の広告は layout/common.vue に記載) -->
      <div
        id="2.5web_clothes_atf"
        class="ads-atf"
      />
      <ClothesTable
        :pickup-list="pickupList"
        :pickup-title="'各地の服装予報'"
      />
      <ClothesLegend />
      <ClothesSearch />
      <ClothesHistory :history-data="showHistory" />
    </NuxtLayout>
  </div>
</template>

<style scoped>
  .ads-atf {
    min-height: 50px;
    margin: 0px auto 10px;
    text-align: center;
    position: relative;
  }
</style>
